import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { useReportCurrency } from "@/profitability/currency";
import { describeMatch, type MatchedCheck } from "./format";

const showLabel = (count: number) =>
  count === 1
    ? "Show the matching figure"
    : `Show the ${count} matching figures`;

export const MatchedFigures = ({ matched }: { matched: MatchedCheck[] }) => {
  const [open, setOpen] = useState(false);
  const currency = useReportCurrency();
  if (!matched.length) return null;

  return (
    <Stack gap={1} align="stretch" className="w-full">
      <Stack direction="row">
        <Button
          size="sm"
          variant="ghost"
          aria-expanded={open}
          onClick={() => setOpen((shown) => !shown)}
        >
          {open ? "Hide the matching figures" : showLabel(matched.length)}
        </Button>
      </Stack>
      {open && (
        <ul className="list-disc pl-5" data-testid="matched-figures">
          {matched.map((check) => (
            <li key={check.label} className="[overflow-wrap:anywhere]">
              <Text tone="muted">{describeMatch(check, currency)}</Text>
            </li>
          ))}
        </ul>
      )}
    </Stack>
  );
};
